import React from "react"

const Grid = ({ children, columnQuantity = 3, marginTop }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${columnQuantity}, 1fr)`,
        gap: 16,
        marginTop,
      }}
    >
      {children}
    </div>
  )
}

export default Grid
